import {BiotronCommandsData, BiotronDb} from "@/components/BiotronPage/BiotronIDB"

const appendU7 = (bytes, value) => {
  bytes.push(Math.min(127, Math.max(0, Math.round(Number(value)))))
}

for (const name of ["noteDistance", "firstValue"]) {
  const command = BiotronCommandsData.get(name)
  command.max_value = 127
  command.fold_function = appendU7
}

export {BiotronCommandsData, BiotronDb}
